import { Box, Flex } from "@chakra-ui/react";
import { getUserDetailsUsingDsrMembersArray } from '../../profile/helpers/user-helper';
import { IoCalendarOutline } from "react-icons/io5";
import { formatDisplayDateOnly } from '../helpers/timestamp-display-helper';
import DsrDisplayAssignedMembersAvatar from '../dsr-team-mgmt/DsrDisplayAssignedMembersAvatar';

import { AiFillCheckCircle } from 'react-icons/ai'
import { GoCircle } from 'react-icons/go'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';

export default function DisplayActionDetailsModal({ showModal, actionItem, handleCloseActionDetailsModal, dsrTeamMembers, isMobileView } ) {

  const renderStatusTag = (actionStatus) => {
    switch (actionStatus) {
      case ('active'): {

        return (
          <Flex position='relative' justify='flex-start'>
            <Flex rounded='36px' bg='#EDF2F7' color='gray.500' px='0.5em' py='0.375em' justify='space-apart' align='center'>
              <Box as={GoCircle} />
              <Box px='0.5em'>To do</Box>
            </Flex>
          </Flex>
        )
      }
      case ('completed'): {
        return (
          <Flex position='relative' justify='flex-start'>
            <Flex rounded='36px' bg='#48BB78' color='white' px='0.5em' py='0.375em' justify='space-apart' align='center'>
              <Box as={AiFillCheckCircle} />
              <Box px='0.5em'>Completed</Box>
            </Flex>
          </Flex>

        )
      }
      default: {
        console.log('Error Code BSTBOJ: There is no action status available.')
        return null;
      }
    }
  }

  const renderMemberName = (userId) => {
    let memberName = "";

    if (userId) {
      const userProfile = getUserDetailsUsingDsrMembersArray(dsrTeamMembers, userId);
      memberName = userProfile ? userProfile.memberName : '-'
    }

    return memberName;
  }

  if (!showModal) {
    return null;
  }

  if (showModal) {
    const { actionStatus, actionCreatedAt, actionDateCompleted, assignedToUserId, actionDueDate, actionTaskDescription, actionTaskTitle, actionCreatedByUserId, actionCompletedByUserId } = actionItem || {};

    const displayedDueDate = actionDueDate && formatDisplayDateOnly(actionDueDate)

    return (
      <LaunchdeckModal
        title={actionTaskTitle}
        handleCloseModal={handleCloseActionDetailsModal}
        showModal={true}
        maxW='35em'
      >
        <>
          <Flex className='action-detail-container' gap={['0.5em','2em']} direction={['column','row']}>
            <Box className="action-detail-label" w={['100%','10em']} >
              Description
            </Box>

            <Box className="action-detail-text-value">
              {actionTaskDescription || "-"}
            </Box>
          </Flex>

          <Flex className='action-detail-container' gap={['0.5em','2em']} direction={['column','row']}>
            <Box className="action-detail-label" w={['100%','10em']}>
              Due date
            </Box>

            <Box className="action-detail-display">
              {displayedDueDate ?
                <Flex whiteSpace='nowrap' w='100%' justify='flex-start'>
                  <Flex className='due-date-button' cursor='default'>
                    <Box as={IoCalendarOutline} boxSize='1em' className='due-date-button__icon' />
                    <Box className='due-date-button__button-text'>{displayedDueDate}</Box>

                  </Flex>
                </Flex> : <Box className="action-detail-text-value">
                  {"-"}
                </Box>
              }
            </Box>
          </Flex>

          <Flex className='action-detail-container' gap={['0.5em','2em']} direction={['column','row']}>
            <Box className="action-detail-label" w={['100%','10em']}>
              Status
            </Box>

            <Box className="action-detail-display">
              {renderStatusTag(actionStatus)}
            </Box>
          </Flex>

          <Flex className='action-detail-container' gap={['0.5em','2em']} direction={['column','row']}>
            <Box className="action-detail-label" w={['100%','10em']}>
              Assigned to
            </Box>

            <Box className="action-detail-display">
              <Box ml={isMobileView ? '-1em' : '-1.5em'}>
                <DsrDisplayAssignedMembersAvatar
                  dsrTeamMembers={dsrTeamMembers}
                  assignedToUsers={assignedToUserId}
                  maxDisplayedAvatars={5}
                />
              </Box>
            </Box>
          </Flex>

          <Flex className='action-detail-container' gap={['0.5em','2em']} direction={['column','row']}>
            <Box className="action-detail-label" w={['100%','10em']}>
              Created
            </Box>

            <Box className="action-detail-display">
              {actionCreatedAt ? `${formatDisplayDateOnly(actionCreatedAt)} by ${renderMemberName(actionCreatedByUserId)}` : "-"}
            </Box>
          </Flex>

          <Flex className='action-detail-container-last-row' gap={['0.5em','2em']} direction={['column','row']}>
            <Box className="action-detail-label" w={['100%','10em']}>
              Completed
            </Box>

            <Box className="action-detail-display">
              {actionDateCompleted ? `${formatDisplayDateOnly(actionDateCompleted)} by ${renderMemberName(actionCompletedByUserId)}` : "-"}
            </Box>
          </Flex>
        </>

      </LaunchdeckModal>

    )
  }
}
